// Safety net for MF runtime rejections that don't make it back to React
// Router's lazy() promise chain (e.g. background manifest preloads that
// fail before any route navigates). Without this they surface as
// "Uncaught (in promise)" in the browser console AND can prevent the React
// tree from continuing to render in some browsers. React Router still
// renders the per-route ErrorPage when the rejection IS reachable via the
// lazy loader — this just stops the parallel rejection from breaking the
// host shell. Errors are still logged (downgraded to warn) for debugging.
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message =
    reason instanceof Error ? reason.message : String(reason ?? '');
  if (
    message.includes('Federation Runtime') ||
    message.includes('#RUNTIME-')
  ) {
    event.preventDefault();
    // eslint-disable-next-line no-console
    console.warn(
      '[distro] Swallowed MF runtime rejection (route-level ErrorPage will surface this if the route was navigated):',
      reason,
    );
  }
});

// Dynamic `import('./bootstrap')` defers the load of shared singletons
// (react, react-dom, react-router-dom) until after this entry's MF runtime
// has been initialized — required by Module Federation's eager-consumption
// rule. Remote URLs are baked into the bundle at build time by
// ModuleFederationPlugin (see rspack.config.js), so there is no runtime
// registration step.
void import('./bootstrap');

export {};
